<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="View Onboarded Intellibaby Students">
        <v-card-text class="pt-0 pr-1"
        :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <!--Filter section end -->
        <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            @input="searchData"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
      </v-card-text>
        <v-divider class=" my-0 " />
        <v-skeleton-loader v-if="skeletonLoaderFlag" type="table-thead, table-tbody"></v-skeleton-loader>
        <v-data-table
          v-else
          :headers="headers"
          :items="resultArray"
          :footer-props="{
            'items-per-page-options': [5 ,10, 20, 40]
          }"
          :items-per-page="10"
          update:page="page"
        >
          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'viewStudentClassDetails', params: { studentID: item.studentID } }">
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon color="black" small> mdi-eye</v-icon>
              </v-btn>
            </router-link>
            <router-link :to="{ name: 'editStudentClassDetails', params: { studentID: item.studentID } }">
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                <v-icon small> mdi-pencil</v-icon>
              </v-btn>
            </router-link>
             <router-link :to="{ name: 'addNewClass', params: { studentID: item.studentID} }">
              <v-btn class="px-2 ml-1 ma-1" color="accent" min-width="0" small>
                <v-icon small> mdi-plus</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import Stores from '@/stores'
export default {
  name: 'ListUser',
  components: {
    MaterialCard
  },
  // props: {
  //   checkable: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data () {
    return {
      page: 1,
      academicYears: [],
      franchisees: [{ id: '', companyName: 'Select All' }],
      headers: [
        { text: 'Sr.No.', value: 'srno', sortable: true },
        { text: 'Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Gender', value: 'studentEnrollment.gender', sortable: true },
        { text: 'Onboard Date', value: 'onboardedDate', sortable: true },
        { text: 'Intellibaby Class', value: 'studentClass.name', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      academicYearID: '',
      selectedFranchisee: '',
      search: '',
      resultArray: [],
      searchFilterArray: [],
      data: [],
      total: 0,
      isLoading: false,
      models: [],
      loadingComponent: null,
      skeletonLoaderFlag: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: function (newVal) {
      this.selectedFranchisee = newVal.id
    },
    academicYear: function (newVal) {
      this.academicYearID = newVal.id
    },
    selectedFranchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.getIntellibabyStudentDetails()
      }
    },
    academicYearID: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.getIntellibabyStudentDetails()
      }
    }
  },
  created () {
    this.onFranchiseeChange()
  },
  methods: {
    getFranchiseeDataFromIndexDB: function () {
      let obj = Stores.user.franchisee
      return obj
    },
    onFranchiseeChange: async function () {
      if (this.franchisee && this.franchisee.id) {
        this.selectedFranchisee = this.franchisee.id
      } else {
        let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
        this.selectedFranchisee = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
      }
      if (this.academicYear) {
        this.academicYearID = this.academicYear.id
      } else {
        this.academicYearID = ''
      }
      if (!this.selectedFranchisee) {
        Utils.helper.openDrawer(this)
      } else {
        Utils.helper.openDrawer(this, false)
      }
    },
    getIntellibabyStudentDetails: async function () {
      try {
        this.skeletonLoaderFlag = true
        this.page = 1
        this.total = 0
        this.data = []
        this.resultArray = []
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/mother-toddler/details?franchiseeID=${this.selectedFranchisee}&academicYearID=${this.academicYearID}&search=${this.search}`)
        this.data = response.data
        this.resultArray = this.data.rows
        this.resultArray = response.data.rows.map((item, index) => {
          item.srno = index + 1
          item.onboardedDate = item.studentEnrollment ? moment(item.studentEnrollment.dateOFAdmission).format('DD MMM YYYY') : '-'
          return item
        })
        this.skeletonLoaderFlag = false
        this.isLoading = false
      } catch (e) {
        this.skeletonLoaderFlag = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('Error in fetching intellibaby student details : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getIntellibabyStudentDetails()
      } else { this.getIntellibabyStudentDetails() }
    }

  }
}
</script>
